import { useMediaListener, BREAKPOINTS } from '@xing-com/util';
import { Column } from '@xing-com/xing-grid';

import { Styled } from './styles';

const RecruitersRecommendationSkeletonHandheld: React.FC = () => {
  return (
    <Styled.RecruitersRecommendationsSkeletonContainerHandheld>
      <Styled.RecruitersRecommendationsSkeletonProfileImageHandled size="xxlarge" />

      <Styled.RecruitersRecommendationsCardSkeletonBodyCopy amountRows={1} />
      <Styled.RecruitersRecommendationsCardSkeletonBodyCopy amountRows={1} />
      <Styled.RecruitersRecommendationsCardSkeletonBodyCopy amountRows={2} />

      <Styled.RecruitersRecommendationsButton />
    </Styled.RecruitersRecommendationsSkeletonContainerHandheld>
  );
};

const RecruitersRecommendationSkeletonBigScreen: React.FC = () => {
  return (
    <Styled.RecruitersRecommendationsCardContainer>
      <Styled.RecruitersRecommendationsSkeletonProfileImageBigScreen size="xlarge" />

      <Styled.RecruitersRecommendationsCardSkeletonBodyCopy amountRows={1} />
      <Styled.RecruitersRecommendationsCardSkeletonBodyCopy amountRows={1} />
      <Styled.RecruitersRecommendationsCardSkeletonBodyCopy amountRows={2} />

      <Styled.RecruitersRecommendationsButton size="small" />
    </Styled.RecruitersRecommendationsCardContainer>
  );
};

const RecruitersRecommendationsSkeleton: React.FC = () => {
  const breakpoint = useMediaListener();
  const isHandheld = breakpoint === BREAKPOINTS.handheld;

  return (
    <Styled.RecruitersRecommendationsSkeleton>
      <Styled.RowContainer>
        {isHandheld ? (
          <>
            <Column size={6}>
              <RecruitersRecommendationSkeletonHandheld />
            </Column>
            <Column size={6}>
              <RecruitersRecommendationSkeletonHandheld />
            </Column>
            <Column size={6}>
              <RecruitersRecommendationSkeletonHandheld />
            </Column>
            <Column size={6}>
              <RecruitersRecommendationSkeletonHandheld />
            </Column>
          </>
        ) : (
          <>
            <Column size={4}>
              <RecruitersRecommendationSkeletonBigScreen />
            </Column>
            <Column size={4}>
              <RecruitersRecommendationSkeletonBigScreen />
            </Column>
            <Column size={4}>
              <RecruitersRecommendationSkeletonBigScreen />
            </Column>
          </>
        )}
      </Styled.RowContainer>
    </Styled.RecruitersRecommendationsSkeleton>
  );
};

export default RecruitersRecommendationsSkeleton;
